import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import './BossModeStats.styles.scss';

type BossModeStatsProps = {
  className?: string;
};

const BossModeStats: React.FC<BossModeStatsProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classes = classNames('boss-mode-stats', className);

  return (
    <div className={classes}>
      <h1>{t('bossModeOperations')}</h1>

      <Outlet />
    </div>
  );
};

export default BossModeStats;
